var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49922 5.39993C8.50511 5.39993 7.69922 4.59404 7.69922 3.59993C7.69922 2.60581 8.50511 1.79993 9.49922 1.79993C10.4933 1.79993 11.2992 2.60581 11.2992 3.59993C11.2992 4.59404 10.4933 5.39993 9.49922 5.39993Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49922 10.7999C8.50511 10.7999 7.69922 9.99404 7.69922 8.99993C7.69922 8.00581 8.50511 7.19993 9.49922 7.19993C10.4933 7.19993 11.2992 8.00581 11.2992 8.99993C11.2992 9.99404 10.4933 10.7999 9.49922 10.7999Z",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49922 16.1999C8.50511 16.1999 7.69922 15.394 7.69922 14.3999C7.69922 13.4058 8.50511 12.5999 9.49922 12.5999C10.4933 12.5999 11.2992 13.4058 11.2992 14.3999C11.2992 15.394 10.4933 16.1999 9.49922 16.1999Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalOptions);
export default __webpack_public_path__ + "static/media/vertical-options.b07a7e1ef535eb4d95756da637d2347b.svg";
export { ForwardRef as ReactComponent };